<template>
  <div class="item-base">
    <user-detail-title
      first-bread="首页管理"
      second-bread="服务项目"
      third-bread="服务项目查看"
      first-url="/user/sign"
      second-url="/user/service_concept"
      title-name="服务项目查看"
    >
    </user-detail-title>
    <user-detail-base style="height: 81vh;">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="大类">
          <span>{{ LookData.typeStr }}</span>
        </el-form-item>
        <el-form-item label="小类">
          <span>{{LookData.smallTypeStr}}</span>
        </el-form-item>
        <el-form-item label="图片">
          <el-image class="item-image" :src="'http://'+LookData.photoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="描述">
          <pre>{{LookData.description}}</pre>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "ConceptLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/serveItem/getById/'+id).then(res=>{

          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>